import axios from '../dataSources/default';

import { getUserDetails } from '../UserService';
import { isSofologist } from '../AuthService';
import { registerCardPayment } from './PaymentService';
import { gtmPayment } from '../gtmService';
import { config } from '../../config';

const ADYEN_CONFIG = config.URLS.ADYEN;

export function createPaymentSession(isSofologist, userId, orderRef, orderNo, amount) {
    const checkAccessPromise = isSofologist ? validateSofologistAccess() : Promise.resolve();

    return checkAccessPromise
        .then(() => prepareInitialPaymentData(userId, orderRef, orderNo, amount))
        .then((initialPaymentData) => sendRequest(initialPaymentData, isSofologist));
}

export function createAdyenDropInConfiguration(paymentSession, onSuccess, onError, onFocus) {
    return {
        environment: ADYEN_CONFIG.ENVIRONMENT,
        clientKey: ADYEN_CONFIG.CLIENT_KEY,
        analytics: {
            enabled: false,
        },
        session: {
            id: paymentSession.sessionId,
            sessionData: paymentSession.sessionData,
        },
        onPaymentCompleted: (result) => {
            if (isSuccessfulPaymentResultCode(result.resultCode)) {
                onSuccess(paymentSession.vendorTxCode);
            } else {
                onError();
            }
        },
        onError: () => {
            onError();
        },
        paymentMethodsConfiguration: {
            card: {
                hasHolderName: true,
                holderNameRequired: true,
                onFocus: () => {
                    onFocus();
                }
            },
            threeDS2: {
                challengeWindowSize: '01'
            }
        }
    };
}

export function saveSuccessfulCardPayment(userGuid, orderIdx, amount, vendorTxCode, orderData) {
    const paymentResult = {
        statusCode: 'Ok',
        statusDetail: 'Authorized',
        amount: amount,
        status: 'Ok',
        vendorTxCode: vendorTxCode
    };

    try {
        gtmPayment(orderData, paymentResult);
    } catch (e) { }

    return registerCardPayment(userGuid, orderIdx, paymentResult);
}

function sendRequest(data, isSofologist) {
    const createSessionUrl = isSofologist
        ? ADYEN_CONFIG.SOFOLOGIST_CREATE_PAYMENT_SESSION
        : ADYEN_CONFIG.CUSTOMER_CREATE_PAYMENT_SESSION;

    return axios.post(createSessionUrl, data, { headers: { 'Content-Type': 'application/json', } })
        .then(response => response.data);
}

function prepareInitialPaymentData(userId, orderRef, orderNo, amount) {
    const orderNumber = `${orderRef}-${orderNo}`;

    return getUserDetails(userId)
        .then((user) => {
            const billingAddress = user.addresses.find(a => a.type.toLowerCase() === 'billing') || user.addresses[0];
            const deliveryAddress = user.addresses.find(a => a.type.toLowerCase() === 'delivery') || user.addresses[0];
            const email = user.emailAddresses.find(e => e.primary) || user.emailAddresses[0];
            const phoneNumber = user.phoneNumbers.find(p => p.primary) || user.phoneNumbers[0];

            const initialPaymentData = {
                basketCode: orderNumber,
                pointOfSale: 'HQ-INTERNET',
                amount,
                language: navigator.language,
                customer: {
                    customerId: userId,
                    firstName: user.firstName || user.title,
                    lastName: user.surname,
                    billingAddress: createAddressRequestModel(billingAddress),
                    deliveryAddress: createAddressRequestModel(deliveryAddress),
                    email: email ? email.address : null,
                    phoneNumber: phoneNumber ? phoneNumber.number : null
                },
                // looks like it's not used for card payment, but still required by Adyen api
                redirectUrl: ADYEN_CONFIG.REDIRECT_URL
            };

            return Promise.resolve(initialPaymentData);
        });
}

function createAddressRequestModel(address) {
    let street = address.line1 || '';
    if (address.houseNameNumber && address.houseNameNumber.length > 0) {
        street = street.replace(`${address.houseNameNumber} `, '');
    }

    const city = address.line2 || '';
    const country = 'GB';
    const houseNumberOrName = address.houseNameNumber || '';
    const postcode = address.postCode || '';

    return {
        city: city.trim(),
        country: country.trim(),
        houseNumberOrName: houseNumberOrName.trim(),
        street: street.trim(),
        postcode: postcode.trim(),
    };
}

function validateSofologistAccess() {
    return isSofologist().then((res) => {
        if (!res.data) return Promise.reject('Unauthorized');
        return Promise.resolve();
    });
}

function isSuccessfulPaymentResultCode(resultCode) {
    return resultCode === 'Authorised';
}


// WEBPACK FOOTER //
// ./src/services/payment/AdyenPaymentService.js